import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";
import Limits from './Limits';
import Derivatives from './Derivatives';
import Integrals from './Integrals';
import Series from "./Series";


const ChangeComponents = {
    limits: Limits,
    derivatives: Derivatives,
    integrals: Integrals,
    series: Series,
  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }